export default __webpack_public_path__ + "img/2dc57346a13d3952f0a837f2f3381031.svg";